import React from 'react';

interface ErrorIllustrationProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

export const ErrorIllustration: React.FC<ErrorIllustrationProps> = ({
  className,
  width = '100%',
  height = '100%',
}) => {
  return (
    <div className={className} style={{ width, height }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 480 360"
        fill="none"
      >
        <defs>
          <linearGradient id="errorBG" x1="19.496%" x2="77.479%" y1="71.822%" y2="16.69%">
            <stop offset="0%" stopColor="hsl(var(--nextui-danger))" />
            <stop offset="100%" stopColor="hsl(var(--nextui-danger))" stopOpacity="0" />
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g>
            <path
              fill="url(#errorBG)"
              fillRule="nonzero"
              d="M0 198.78c0 41.458 14.945 79.236 39.539 107.786 28.214 32.765 69.128 53.365 114.734 53.434a148.44 148.44 0 0056.495-11.036c9.051-3.699 19.182-3.274 27.948 1.107a75.779 75.779 0 0033.957 8.01c5.023 0 9.942-.494 14.7-1.433 13.58-2.67 25.94-8.99 36.09-17.94 6.378-5.627 14.547-8.456 22.897-8.446h.142c27.589 0 53.215-8.732 74.492-23.696 19.021-13.36 34.554-31.696 44.904-53.224C474.92 234.58 480 213.388 480 190.958c0-76.93-59.774-139.305-133.498-139.305-7.516 0-14.88.663-22.063 1.899C305.418 21.42 271.355 0 232.499 0a103.651 103.651 0 00-45.88 10.661c-13.24 6.487-25.011 15.705-34.64 26.939-32.698.544-62.931 11.69-87.676 30.291C25.351 97.155 0 144.882 0 198.781z"
              opacity="0.2"
            />
            <circle cx="240" cy="180" r="80" fill="hsl(var(--nextui-danger) / 0.1)" />
            <circle cx="240" cy="180" r="60" fill="hsl(var(--nextui-danger) / 0.2)" />
            <path
              d="M240 140 L240 180 M240 200 L240 210"
              stroke="hsl(var(--nextui-danger))"
              strokeWidth="8"
              strokeLinecap="round"
            />
            <circle cx="240" cy="210" r="5" fill="hsl(var(--nextui-danger))" />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default ErrorIllustration;
